var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.995,
    viewBox: "189 320.003 36 35.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.813 346.997h-5.625a1.683 1.683 0 0 1-1.688-1.687v-11.813h-6.166c-1.252 0-1.878-1.511-.992-2.397l10.695-10.702a1.362 1.362 0 0 1 1.92 0l10.7 10.702c.887.886.261 2.397-.99 2.397H211.5v11.813c0 .935-.752 1.687-1.688 1.687Zm15.187-.562v7.875c0 .935-.752 1.687-1.688 1.687h-32.625A1.683 1.683 0 0 1 189 354.31v-7.875c0-.935.752-1.688 1.688-1.688h9.562v.563a3.94 3.94 0 0 0 3.938 3.937h5.625a3.94 3.94 0 0 0 3.937-3.937v-.563h9.563c.935 0 1.687.753 1.687 1.688Zm-8.719 6.187a1.41 1.41 0 0 0-1.406-1.406 1.41 1.41 0 0 0-1.406 1.406 1.41 1.41 0 0 0 1.406 1.407 1.41 1.41 0 0 0 1.406-1.407Zm4.5 0a1.41 1.41 0 0 0-1.406-1.406 1.41 1.41 0 0 0-1.406 1.406 1.41 1.41 0 0 0 1.406 1.407 1.41 1.41 0 0 0 1.406-1.407Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon awesome-upload"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/FileUploadIcon.041b630f285b67f4d08be61a91b52d7d.svg";
export { ForwardRef as ReactComponent };